mobileSize = 1000;
function countdown() {
    if ($('body').hasClass('saffireMobileSize')) {
        $('#siteInfoBannerWidget').appendTo('.header-top');
    } else {
        $('#siteInfoBannerWidget').prependTo('.header-column-right-top');
    }
}
$(window).load(function () {
    $(".footerItems1 a").removeClass("button");
    // Weather Bug
    setInterval(function () {
        var str = $('#weatherBugDescription').text();
        var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
        if (!weatherBugSet && str != '') {
            $('#weatherBugWidget').addClass('weatherBugSet');
            var findSpace = str.lastIndexOf(' ');
            var stringLength = str.length;
            var res = str.substring(findSpace, stringLength);
            var start = str.substring(0, findSpace);
            $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
            $('#weatherBugWidget').css('visibility', 'visible');
        }
    }, 12);
    $(".generalmessage").prependTo(".header");
    //prepend general message into header
    if ($("body").hasClass("generalMessageOn")) {
        $(".generalmessage").prependTo(".header");
    }
    $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
    const windowSize = $(window).width();
    if (windowSize < 1000) {
        $('body')
            .addClass('saffireMobileSize')
            .removeClass('saffireLargeSize');
    } if (windowSize > 1000) {
        $('body').removeClass('saffireMobileSize');
    }
    countdown();
});
$(document).ready(function () {
    if ($('body').hasClass('nacogdoches-subpage-theme')) {
        $('#MainContent_content_uc_entityModuleContainerDisplay_rptr_rows_rptr_columns_1_div_column_0').prependTo('.wrapper');
    }
    $(".footerItems1 a").removeClass("button");
    
    const fes = $('.header .searchBox');

    const fesInputSearch = fes.find(".searchBoxInput input");
    fesInputSearch.attr("value", "");
    fesInputSearch.attr("placeholder", "search");

    fesInputSearch.on("focus", function () {
      $(this).attr("placeholder", "");
    });

    fesInputSearch.on("blur", function () {
      $(this).attr("placeholder", "search");
    });

    const fes1 = $('.tier-four-right .emailSignup ');
    fes1.find('.emailInputSubmit a').text('Sign Up');

    fes1.find('.emailSignupText').text('Get the Latest News and Special Offers');
    fes1.find('.inputFieldTextbox').val('');
    fes1.find('.inputFieldTextbox').attr('placeholder', 'Enter email address');
    countdown();
});

$(window).resize(function () {
    $(".footerItems1 a").removeClass("button");
    countdown();
});